import {
  CREATE_ORDER_NEW_RECORD,
  CREATE_ORDER_NEW_RECORD_SUCCESS,
  CREATE_ORDER_NEW_RECORD_ERROR,  
  
  GET_ORDER_NEW_RECORD,
  GET_ORDER_NEW_RECORD_SUCCESS,
  GET_ORDER_NEW_RECORD_ERROR,  

  SET_RECORD_TYPE,
  PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
  PANEL_NEW_RECORD_HIDE_CLICK,
  UPDATE_NEW_RECORD_STATE,

  GET_ORDER_LINEITEMS,
  GET_ORDER_LINEITEMS_SUCCESS,
  GET_ORDER_LINEITEMS_ERROR,   
} from "../actions";

export const getRecords = (recordType, pageNumber, displayStatus, parentRecordId, selectedFilters, orderId, hasUserAccount, profile, params, searchInputName) => ({
  type: GET_ORDER_LINEITEMS,
  payload: { recordType, pageNumber, displayStatus, parentRecordId, selectedFilters, orderId, hasUserAccount, profile, params, searchInputName },
});

export const getRecordsSuccess = (recordList) => ({
  type: GET_ORDER_LINEITEMS_SUCCESS,
  payload: recordList,
});

export const getRecordsError = (message) => ({
  type: GET_ORDER_LINEITEMS_ERROR,
  payload: { message },
});

export const getOrderItemNewRecord = (orderId, history) => ({
    type: GET_ORDER_NEW_RECORD,
    payload: {orderId, history}
  });

export const getOrderItemNewRecordSuccess = (recordCreated) => ({
  type: GET_ORDER_NEW_RECORD_SUCCESS,
  payload: recordCreated,
});

export const getOrderItemNewRecordError = (message) => ({
  type: GET_ORDER_NEW_RECORD_ERROR,
  payload: { message },
});

export const createOrderItemNewRecord = (newRecord, history) => ({
    type: CREATE_ORDER_NEW_RECORD,
    payload: {newRecord, history}
  });

export const createOrderItemNewRecordSuccess = (recordCreated) => ({
  type: CREATE_ORDER_NEW_RECORD_SUCCESS,
  payload: recordCreated,
});

export const createOrderItemNewRecordError = (message) => ({
  type: CREATE_ORDER_NEW_RECORD_ERROR,
  payload: { message },
});


export const hideNewRecordPanel = () => ({
    type: PANEL_NEW_RECORD_HIDE_CLICK,
    payload: {},
  });

export const toggleNewRecordPanel = () => ({
    type: PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
    payload: {},
  });

export const setRecordType = (recordTypeSelected) => ({
    type: SET_RECORD_TYPE,
    payload: {recordTypeSelected},
  });

export const updateNewRecordState = (updatedValues) => ({
  type: UPDATE_NEW_RECORD_STATE,
  payload: { updatedValues }
});